import axios, { AxiosResponse } from 'axios';

import {
    PUBLIC_ADDRESS_API_URL_ENV,
    PUBLIC_ADDRESS_API_KEY_ENV,
} from 'tools/environments';

import { GetAddressResponse } from './types/get-address.type';

export const getAddress = async (
    id: string
): Promise<AxiosResponse<GetAddressResponse>> => {
    const apiUrl = `${PUBLIC_ADDRESS_API_URL_ENV}/get/${id}?api-key=${PUBLIC_ADDRESS_API_KEY_ENV}`;

    const response = await axios.get(apiUrl, {
        headers: {
            'Content-Type': 'application/json',
        },
    });

    return response;
};
